import { createAsyncThunk } from "@reduxjs/toolkit";
import { Classificacao } from "model/classificacao/Classificacao";
import { CriacaoClassificacaoDTO } from "model/classificacao/CriacaoClassificacaoDTO";
import { Api } from "service/api/Api";
import { ApiClassificacao } from "service/api/classificacao/ApiClassificacao";
import { ErrosUtils } from "util/ErrosUtils";



export class ClassificacaoAction {
  static readonly iniciar = createAsyncThunk(
    'Classificacao/listar/iniciar',
    async (it, {rejectWithValue}) => {
      try {
        return await ApiClassificacao.classificacoes();
      } catch (e) {
        return rejectWithValue(ErrosUtils.converterErroAxiosParaErroSistema(e));
      }
    }
  )

  static readonly addClassificacao = createAsyncThunk(
    'Classificacao/adicionar',
    async (classificacao: Classificacao, {rejectWithValue}) => {

      const classificacaoDTO: CriacaoClassificacaoDTO = {
        id: null,
        nome: classificacao.nome,
        paiId: classificacao.paiId ?? null,
        reinoId: Api.REINO_PADRAO,
        unidadeId: classificacao.unidadeId ?? null
      }
      
      try {
        return await ApiClassificacao.adicionar(classificacaoDTO);
      } catch (e) {
        return rejectWithValue(ErrosUtils.converterErroAxiosParaErroSistema(e));
      }
    }
  );

  static readonly updateClassificacao = createAsyncThunk(
    'Classificacao/atualizar',
    async (classificacao: Classificacao, {rejectWithValue}) => {

      const classificacaoDTO: CriacaoClassificacaoDTO = {
        id: classificacao.id ?? null,
        nome: classificacao.nome,
        paiId: classificacao.paiId ?? null,
        reinoId: classificacao.reinoId ?? null,
        unidadeId: classificacao.unidadeId ?? null
      }
      
      try {
        return await ApiClassificacao.adicionar(classificacaoDTO);
      } catch (e) {
        return rejectWithValue(ErrosUtils.converterErroAxiosParaErroSistema(e));
      }
    }
  );
}
